import { Collapse as AntCollapse } from "@/config/antd";
import PropTypes from "prop-types";
import "@/assets/styles/collapsable.css";

const Collapse = ({ items = [], defaultActiveKey = ["1"] }) => {
  return (
    <AntCollapse
      defaultActiveKey={defaultActiveKey}
      expandIconPosition="end"
      className="mt-4 custom-collapse"
      bordered={false}
      ghost={true}
      items={items.map((item) => ({
        key: item.key,
        label: (
          <div className="flex items-center gap-3">
            <div className="w-[15px] h-[15px] rounded-full bg-primary"></div>
            <span className="font-bold text-black lg:heading-medium">
              {item.header}
            </span>
          </div>
        ),
        children: <div className="pl-8">{item.content}</div>,
        className: "bg-transparent",
      }))}
    />
  );
};

Collapse.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      header: PropTypes.string,
      content: PropTypes.node,
    })
  ),
  defaultActiveKey: PropTypes.arrayOf(PropTypes.string),
};

export default Collapse;
